import { render, staticRenderFns } from "./tentative-sales-list.vue?vue&type=template&id=63d10aef&scoped=true&"
import script from "./tentative-sales-list.vue?vue&type=script&lang=js&"
export * from "./tentative-sales-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d10aef",
  null
  
)

export default component.exports